<template>
  <div>
    {{ $t('key_text_pagination_from') }} {{ (current-1)* rows +1 }} {{ $t('key_text_pagination_to') }} {{ endRow }} {{ $t('key_text_pagination_of') }} {{ total }} {{ $t('key_text_pagination_records') }}
  </div>
</template>
<script>
export default {
  name: "PaginationInfo",
  props: {
    total:{
      type: Number,
      default:1
    },
    current: {
      type: Number,
      default:1
    },
    rows:{
      type:Number,
      default:1
    }

  },
  computed: {
    endRow(){
      let totalPages = Math.ceil(this.total / this.rows);
      return totalPages === this.current ? this.total : this.current * this.rows;
    }
  }
};
</script>
